export const VARIANT_PRODUCT_SEARCH_FIELDS = 'BASIC,images(FULL),unit,data';
export const PRODUCT_SEARCH_FIELDS = 'DEFAULT,data,supplierAlternativeAID';
